import React from 'react';
import RadioButtonGroup from 'material-ui/RadioButton/RadioButtonGroup';
import RadioButton from 'material-ui/RadioButton';
import {PropsObjectType} from "core/form/form";
import {LovItem} from "core/metamodel/mdEntity";
import {lovValue} from "core/form/formUtils";
import {grey500, grey700, red500} from "material-ui/styles/colors";
import isFunction = require("lodash/isFunction");
import Checkbox from "material-ui/Checkbox";
import {ID} from "core/metamodel/metaConstant";

interface CheckBoxGroupFieldProps extends PropsObjectType {
  disabled?: boolean|Function;
  optionStyle?: any;
  iconStyle?: any;
  iconStyleFn?: (value) => any;
  groupStyle: CHECKBOXGROUPSTYLE;
}

export enum CHECKBOXGROUPSTYLE {VERTICAL, HORIZONTAL}

export default class CheckBoxGroupField extends React.PureComponent<CheckBoxGroupFieldProps, undefined> {

  onChangeInner = (lov, evt) => {
    console.log("lov = %o, checked = %s", lov, evt.target.checked);

    let newValues: LovItem[];

    if (evt.target.checked) {
      newValues = this.props.value.slice();
      newValues.push({value: lov.value, label: lov.label});
    } else {
      newValues = this.props.value.filter(v => lovValue(v) !== lov.value);
    }

    this.props.onChange(newValues);
  };


  render() {

    let {
      name,
      value,
      labelStyle,
      inputStyle,
      options,
      onChange,
      optionStyle,
      iconStyle,
      iconStyleFn,
      style,
      errorText,
      disabled,
      groupStyle,
      ...other
    } = this.props;

    if (groupStyle === CHECKBOXGROUPSTYLE.HORIZONTAL) {
      style = {...style, display: 'flex', alignItems: 'center'};
      labelStyle = {...labelStyle, whiteSpace: 'nowrap'};
      iconStyle = {...iconStyle, marginRight: 4, color: grey700};
      optionStyle = {...optionStyle, marginRight: 10};
    }


    console.log('CheckBoxGroupFieldProps value: %o, labelStyle: %o, iconStyle: %o, inputStyle: %o, style %o',  value, labelStyle, iconStyle, inputStyle, style);

    let valueIds: ID[] = value.map(v => lovValue(v));
    let extendedOptions = options.map(op => ({...op, checked: valueIds.includes(lovValue(op))}));

    return (
      <div style={style}>
        {extendedOptions.map((lov, index) => <Checkbox key={index} value={lov.checked} label={lov.label} defaultChecked={lov.checked} onCheck={this.onChangeInner.bind(this, lov)}
                                                  labelStyle={labelStyle} iconStyle={(iconStyleFn) ? iconStyleFn(lov.value) : iconStyle}
                                                  inputStyle={inputStyle} style={optionStyle} disabled={(isFunction(disabled)) ? disabled(lov) : disabled} />)}
        <div style={{fontSize:12, color: red500}}>{errorText}</div>
      </div>

    );
  }


}






// WEBPACK FOOTER //
// ./src/core/components/fields/checkBoxGroupField.tsx